import React, { useEffect, useState } from "react";

const ErrorPage = props => {
    return <div style={{margin: '50px auto 0', maxWidth: 600, textAlign: 'center'}}>
    There was a problem with your session credentials. Please try launching WAY2GO from SWEET again. If problems persist, please contact WAY2GO support.
    </div>
}

export default ErrorPage;